export interface ITeacher {
  readonly avatarSmall: string
  readonly educatorRole: string
  readonly id: string
  readonly link: string
  readonly mainTeacher: boolean
  readonly name: string
  readonly avatar?: string
}